/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.testimonial-carousel-wrapper');

    carousels.forEach(carousel => {
        const track = carousel.querySelector('.carousel-track');
        let cards = Array.from(track.querySelectorAll('.testimonial-card'));
        const dots = carousel.querySelectorAll('.carousel-dot');
        const autoPlay = carousel.dataset.autoplay === 'true';
        const autoPlaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5000;

        if (cards.length < 2) return; // No need for carousel if not enough items

        // Clone slides for infinite loop
        const cloneCount = 2; // Number of clones on each side
        const firstClones = cards.slice(0, cloneCount).map(card => {
            const clone = card.cloneNode(true);
            clone.classList.add('clone');
            clone.classList.remove('active');
            return clone;
        });
        const lastClones = cards.slice(-cloneCount).map(card => {
            const clone = card.cloneNode(true);
            clone.classList.add('clone');
            clone.classList.remove('active');
            return clone;
        });

        // Append/Prepend clones
        firstClones.forEach(clone => track.appendChild(clone));
        lastClones.reverse().forEach(clone => track.insertBefore(clone, track.firstChild));

        // Re-query cards to include clones
        let allCards = track.querySelectorAll('.testimonial-card');
        // Initialize state
        let currentTransform = 0;
        let currentSlide = cloneCount; // Start at first real slide
        let isTransitioning = false;
        let autoPlayInterval;

        function updateCarousel(enableTransition = true) {
            if (allCards.length === 0) return;

            const card = allCards[0];
            const style = window.getComputedStyle(card);
            const cardWidth = card.offsetWidth;
            const marginLeft = parseFloat(style.marginLeft) || 0;
            const marginRight = parseFloat(style.marginRight) || 0;
            const fullCardWidth = cardWidth + marginLeft + marginRight;

            const containerWidth = carousel.querySelector('.carousel-container').offsetWidth;

            // Calculate center position
            const centerOffset = (containerWidth / 2) - (cardWidth / 2) - marginLeft;
            const newTransform = -(currentSlide * fullCardWidth) + centerOffset;

            // Store current transform for drag logic
            currentTransform = newTransform;

            track.style.transition = enableTransition ? 'transform 0.5s ease-in-out' : 'none';
            track.style.transform = `translateX(${newTransform}px)`;

            // Update Active Classes
            let realIndex = (currentSlide - cloneCount) % cards.length;
            if (realIndex < 0) realIndex += cards.length;

            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === realIndex);
            });

            allCards.forEach((c, i) => {
                c.classList.remove('active');
                if (i === currentSlide) {
                    c.classList.add('active');
                }
            });
        }

        // Initial Position
        setTimeout(() => updateCarousel(false), 50);

        function goToSlide(index) {
            if (isTransitioning) return;
            isTransitioning = true;
            currentSlide = index;
            updateCarousel(true);
        }

        // --- Drag / Touch Logic ---
        let isDragging = false;
        let startPos = 0;
        let diff = 0;

        function getPositionX(event) {
            return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
        }

        function touchStart(event) {
            // Prevent default drag behavior if needed, but allow scrolling if vertical?
            // For now, simple start.
            isDragging = true;
            startPos = getPositionX(event);
            diff = 0; // Reset diff
            track.style.transition = 'none'; // Disable transition for 1:1 movement
            // reset autoplay
            if (autoPlay) clearInterval(autoPlayInterval);
        }

        function touchMove(event) {
            if (isDragging) {
                const currentPosition = getPositionX(event);
                diff = currentPosition - startPos;
                track.style.transform = `translateX(${currentTransform + diff}px)`;
            }
        }

        function touchEnd() {
            if (!isDragging) return;
            isDragging = false;

            // Threshold to change slide (e.g., 30px for sensitivity)
            const threshold = 30;

            if (diff < -threshold) {
                // Dragged Left -> Next Slide
                goToSlide(currentSlide + 1);
            } else if (diff > threshold) {
                // Dragged Right -> Prev Slide
                goToSlide(currentSlide - 1);
            } else {
                // Snap back
                updateCarousel(true);
                // Also reset isTransitioning if we didn't call goToSlide? 
                // logical hole: goToSlide sets isTransitioning=true. 
                // updateCarousel just animates. We might need to ensure isTransitioning is correct.
                // Actually goToSlide handles it. If we just snap back, we use updateCarousel. 
                // but we should technically be "transitioning" back.
            }

            if (autoPlay) startAutoPlay();
        }

        // Add Listeners
        track.addEventListener('mousedown', touchStart);
        track.addEventListener('touchstart', touchStart, { passive: true });

        track.addEventListener('mousemove', touchMove);
        track.addEventListener('touchmove', touchMove, { passive: true });

        track.addEventListener('mouseup', touchEnd);
        track.addEventListener('mouseleave', () => { if (isDragging) touchEnd() });
        track.addEventListener('touchend', touchEnd);


        // Handle Transition End for Loop
        track.addEventListener('transitionend', () => {
            isTransitioning = false;
            if (currentSlide < cloneCount) {
                currentSlide = currentSlide + cards.length;
                updateCarousel(false);
            } else if (currentSlide >= cards.length + cloneCount) {
                currentSlide = currentSlide - cards.length;
                updateCarousel(false);
            }
        });

        // Dot Navigation
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                let target = index + cloneCount;
                goToSlide(target);
                if (autoPlay) resetAutoPlay();
            });
        });

        function resetAutoPlay() {
            clearInterval(autoPlayInterval);
            startAutoPlay();
        }

        function startAutoPlay() {
            clearInterval(autoPlayInterval); // ensure clear
            autoPlayInterval = setInterval(() => {
                if (!isTransitioning && !isDragging) { // Check isDragging too
                    goToSlide(currentSlide + 1);
                }
            }, autoPlaySpeed);
        }

        if (autoPlay) {
            startAutoPlay();
        }

        // Pause on hover (keep existing logic)
        carousel.addEventListener('mouseenter', () => {
            if (autoPlay) clearInterval(autoPlayInterval);
        });

        carousel.addEventListener('mouseleave', () => {
            // Don't auto-start if dragging, handled by touchEnd
            if (autoPlay && !isDragging) startAutoPlay();
        });

        // Update on resize
        window.addEventListener('resize', () => {
            updateCarousel(false);
        });
    });
});